var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", {
      domProps: {
        innerHTML: _vm._s(
          _vm.$t("notification.reservationCreated", {
            name: _vm.$_.get(_vm.activity, "payload.userName"),
            visitor: _vm.maskedVisitorFullname,
            date: _vm.$_.get(_vm.activity, "payload.date"),
          })
        ),
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }